/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/auditLog": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Add explicit user event to the audit log */
        post: operations["logUserEvent"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/contig/{contigId}/featureTypes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get available feature types by contig id. */
        get: operations["getContigFeatureTypes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/contig/{contigId}/sequence": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get sequence */
        get: operations["getSequence"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/contig/{contigId}/trackFeatures/{trackType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get track features of a give type by contig ids. Subtype is optional for gene and protein types. */
        get: operations["getTrackFeatures"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/download/filescannerReport": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** download file scanner report preview */
        get: operations["downloadFilescannerReport"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/exportRegion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** prepare export from synteny viewer */
        post: operations["sequenceRegionExport"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/exportTable": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** prepare export from synteny viewer */
        post: operations["tableExport"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/feature/pangenome/{pangenomeOrgId}/{featureId}/info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get pangenome segment info. */
        get: operations["getPangenomeFeature"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/feature/{type}/{featureId}/info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get feature by type and id. */
        get: operations["getFeature"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/feature/{type}/{featureId}/locations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get feature locations */
        get: operations["getFeatureLocation"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/featureRowId": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** get feature's table row index */
        post: operations["featureRowId"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/filescanner/deleteStaleFiles": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** delete files based on stale scan report */
        post: operations["triggerDeletion"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/filescanner/refreshStaleFilesReport": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Build a new stale scan report */
        post: operations["triggerStaleScan"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/genome/componentGenomes/{orgId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get component genomes by orgId */
        get: operations["getComponentGenomes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/genome/usergroupIntersection": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** get usergroup intersection among genomes */
        post: operations["getUsergroupIntersection"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/genome/{orgId}/featureTypes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get available feature types by genome id. */
        get: operations["getGenomeFeatureTypes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/genome/{orgId}/info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get genome info */
        get: operations["getGenomeInfo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/getTemplates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Get templates for this type of table */
        post: operations["getTemplates"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/group": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** create a group */
        post: operations["createGroup"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/preview/filescannerReport": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get file scanner report preview */
        get: operations["previewFilescannerReport"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/preview/projectFile/{fileId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get project file preview */
        get: operations["previewFile"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/search/genomicFeature": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** get search results for the provided term */
        post: operations["getSearchResult"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/createSession": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** create sequence analyzer session */
        post: operations["createSession"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/createSessionFromRanges": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** create sequence analyzer session from regions */
        post: operations["createSessionFromRanges"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/sequenceFeatureColors/{sequenceType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get colors */
        get: operations["getSequenceFeatureColors"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/session/{seqAnalyzerSessionId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** obtain session with the given ID */
        get: operations["getSeqAnalyzerSession"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/session/{seqAnalyzerSessionId}/isValid": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** check whether the session is still available */
        get: operations["isSessionValid"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/session/{seqAnalyzerSessionId}/sequences": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** add sequences to session */
        post: operations["addSequencesToSession"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/session/{seqAnalyzerSessionId}/strands": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** switch specified sequences to opposite strand */
        post: operations["switchStrand"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/validateSequences": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** validate sequences to have valid contents */
        post: operations["validateSequences"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequences/align": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Align Sequences */
        post: operations["align"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequences/order": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Order sequences by similarity */
        post: operations["order"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequences/tree": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Calculate Similarity Tree of Sequences */
        post: operations["tree"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequences/{seqAnalyzerSessionId}/report": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Order sequences to FASTA/MSF file */
        post: operations["exportFile"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/proteinFamily/{familyId}/members": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get protein family members by familyId */
        get: operations["getProteinFamilyMembers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{pangenomeOrgId}/pangenomeAlignment/{familyId}/members": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get pangenome alignment members by familyId */
        get: operations["getPangenomeAlignmentMembers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{pangenomeOrgId}/pangenomeAlignment/{featureType}/{featureId}/members": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get pangenome aligned members for a related feature */
        get: operations["getPangenomeAlignmentFeatureMembers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{pangenomeOrgId}/{contigId}/pangenomeAlignments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get pangenome aligned regions by contig id */
        get: operations["getPangenomeAlignments"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{pangenomeOrgId}/{contigId}/pangenomeAlignments/statistics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * get pangenome alignment statistics by contig id
         * @description Set of statistics indication how many features with a minimum length exist for a specified region.Lengths reference is provided separately in the parent object.
         */
        get: operations["getAlignmentStatistics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{pangenomeOrgId}/{contigId}/trackFeatures": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get pangenome track features of a given type by contig id. */
        get: operations["getPangenomeTrackFeatures"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{syntenyOrgId}/componentGenome/{orgId}/{syntenyType}/alignedContigs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get contigs with synteny families by orgId */
        get: operations["getContigsWithSyntenyFamilies"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{syntenyOrgId}/proteinFamilies": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get protein families by contig ids and synteny organism id */
        get: operations["getProteinFamilies"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{syntenyOrgId}/{syntenyType}/feature/{featureId}/syntenyMembers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get family members of a synteny feature */
        get: operations["getFeatureSyntenyFamilyMembers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/table": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** get table */
        post: operations["table"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/template": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Set the visible columns for a table */
        put: operations["updateTemplate"];
        /** Create a new template for a table */
        post: operations["createTemplate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/template/{templateId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete this template. */
        delete: operations["deleteTemplate"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/view/isProjectCompatible/{projectId}/{organismId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** check project's usergroup compatibility with genome */
        get: operations["isProjectCompatible"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/view/synteny": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** edit a synteny view */
        put: operations["editSyntenyView"];
        /** create a synteny view */
        post: operations["createSyntenyView"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/view/synteny/{viewId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** load synteny view */
        get: operations["loadSyntenyView"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** Aligned Family Request */
        AlignedFamilyRequest: {
            /** Format: int64 */
            familyId?: number;
            members: components["schemas"]["FamilyMemberRequest"][];
        };
        /** Aligned Family Response */
        AlignedFamilyResponse: {
            /** Format: int64 */
            familyId?: number;
            members: components["schemas"]["FamilyMemberResponse"][];
        };
        /** Alignment Bin Stats */
        AlignmentBinStatsResponse: {
            /** @description Each element contain the total count of features with at least the length related to the reference field of the parent object. */
            counts: number[];
            /** Format: int32 */
            start: number;
            /** Format: int32 */
            stop: number;
        };
        /**
         * Alignment Density
         * @enum {string}
         */
        AlignmentDensityEnum: AlignmentDensityEnum;
        /** Alignment Options */
        AlignmentOptions: {
            methodKey: components["schemas"]["MethodKeyEnum"];
            sequences?: components["schemas"]["SlowAlignmentOptions"];
        };
        /** Alignment Stats */
        AlignmentStatsResponse: {
            /** @description Statistics bin counter reference. Elements in the bin counter array contain a length greater than the reference here. */
            binCountsReference: number[];
            bins: components["schemas"]["AlignmentBinStatsResponse"][];
        };
        /**
         * Basic Entity Sequence
         * @description An Entity containing a sequence, such as a Gene, a Transcript or Protein without Feature details
         */
        BasicEntitySequence: {
            /** @default true */
            directStrand: boolean;
            /** Format: int64 */
            id: number;
            name: string;
            qualifiedId: string;
            residues: string;
            sequenceType: components["schemas"]["SequenceType"];
        };
        BlastAlignmentCell: {
            /** Format: int64 */
            queryLength?: number;
            /** Format: int64 */
            queryStart?: number;
            /** Format: int64 */
            queryStop?: number;
            /** Format: int64 */
            targetLength?: number;
            /** Format: int64 */
            targetStart?: number;
            /** Format: int64 */
            targetStop?: number;
        };
        BooleanColumnFilter: {
            filterType: "BooleanColumnFilter";
        } & (Omit<WithRequired<components["schemas"]["ColumnFilter"], "filterType">, "filterType"> & {
            filter: string;
            type: string;
        });
        /** Category Response */
        CategoryResponse: {
            categoryName: string;
            categoryType: components["schemas"]["GenomicFeatureTypeEnum"];
            items: components["schemas"]["ItemResponse"][];
            /** Format: int64 */
            subTypeId: number;
            /** Format: int64 */
            totalItemCount: number;
        };
        /** @description List of row data. Values are keyed by column id, empty if not requested. */
        CellResponseType: components["schemas"]["EntityLink"] | components["schemas"]["ExternalLink"] | components["schemas"]["SampleCell"] | components["schemas"]["BlastAlignmentCell"] | components["schemas"]["ColorValue"] | string | number | boolean;
        /** @enum {string} */
        CellType: CellType;
        ColorValue: {
            color?: string;
            value?: Record<string, never>;
        };
        /** @description Filter model or empty map. */
        ColumnFilter: {
            filterType: string;
        };
        ColumnFilterOptionsResponse: {
            filterType: string;
            operators: components["schemas"]["FilterOption"][];
            values: {
                [key: string]: string;
            };
        };
        /** @description List of row data. Values are keyed by column id, empty if not requested. */
        ColumnMap: {
            empty?: boolean;
        } & {
            [key: string]: components["schemas"]["CellResponseType"];
        };
        /** @description Columns for which data should be returned */
        ColumnRequest: {
            /** @description The unique column id, consisting of column number and namespace id. */
            colId: string;
        };
        /** @description List of columns for which data was requested, empty if not requested. */
        ColumnResponse: {
            cellType: components["schemas"]["CellType"];
            children: components["schemas"]["ColumnResponse"][];
            colId: string;
            field: string;
            filterOptions: components["schemas"]["ColumnFilterOptionsResponse"];
            filterable: boolean;
            fixed: boolean;
            headerName: string;
            hide: boolean;
            sortable: boolean;
        };
        /** @description The list of columns to set */
        ColumnSparseResponse: {
            children?: components["schemas"]["ColumnSparseResponse"][];
            colId: string;
            field: string;
            fixed: boolean;
            headerName: string;
            hide: boolean;
        };
        /** Compatibility Response */
        CompatibilityResponse: {
            isCompatible: boolean;
        };
        /**
         * @description Defines the content to include in the response.
         * @enum {string}
         */
        Content: Content;
        /**
         * Contig Region
         * @description Representation of a region on a contig
         */
        ContigRange: {
            /** Format: int64 */
            contigId: number;
            /** Format: int64 */
            start: number;
            /** Format: int64 */
            stop: number;
            trackColors?: components["schemas"]["TrackColors"];
        };
        /** Contig */
        ContigResponse: {
            /** Format: int64 */
            id: number;
            /** Format: int64 */
            length: number;
            name: string;
        };
        /** Create Group Request */
        CreateGroupRequest: {
            description?: string;
            groupType: components["schemas"]["GroupTypeEnum"];
            itemIds: number[];
            itemTagIds?: number[];
            name: string;
            /** Format: int64 */
            projectId: number;
            shared: boolean;
            /** Format: int64 */
            subTypeId?: number;
        };
        /** Create or Update Synteny View Request */
        CreateOrUpdateSyntenyViewRequest: {
            description?: string;
            /** Format: int64 */
            id?: number;
            itemTagIds?: number[];
            name: string;
            path: string;
            /** Format: int64 */
            projectId: number;
            shared: boolean;
            state: components["schemas"]["StateRequest"];
        };
        CreateTemplateRequest: {
            /** @description Columns to  include */
            columns: components["schemas"]["ColumnSparseResponse"][];
            /** @description The name of the template */
            name: string;
            tableRequest: components["schemas"]["TableRequest"];
        };
        DateColumnFilter: {
            filterType: "DateColumnFilter";
        } & (Omit<WithRequired<components["schemas"]["ColumnFilter"], "filterType">, "filterType"> & {
            dateFrom: string;
            dateTo?: string;
            type: string;
        });
        /** Distance Tree Node */
        DistanceTreeNode: {
            /** Format: double */
            distance?: number;
            /** Format: int64 */
            id?: number;
            left?: components["schemas"]["DistanceTreeNode"];
            right?: components["schemas"]["DistanceTreeNode"];
        };
        EntityLink: {
            /** Format: int64 */
            id?: number;
            label?: string;
            type?: components["schemas"]["LinkTypeEnum"];
        };
        /**
         * Entity Sequence
         * @description An Entity containing a sequence, such as a Gene, a Transcript or Protein
         */
        EntitySequence: {
            chainInfoKey?: string;
            chainInfoLabel?: string;
            circular?: boolean;
            database: string;
            description?: string;
            /** @default true */
            directStrand: boolean;
            entityClassLabelPlural?: string;
            entityClassLabelSingular?: string;
            entityDescription?: string;
            entityLabel?: string;
            entityQualifiedId?: string;
            entityUrl?: string;
            featureType: components["schemas"]["FeatureType"];
            features: components["schemas"]["SequenceFeature"][];
            genome: string;
            /** Format: int64 */
            id: number;
            location?: string;
            name: string;
            qualifiedId: string;
            residues: string;
            sequenceType: components["schemas"]["SequenceType"];
            synonym?: string;
        };
        /** Export Sequences in FASTA/MSF file Request */
        ExportFileRequest: {
            "The  sequence selection"?: components["schemas"]["Selection"];
            "The type of the export file": components["schemas"]["SequenceExportFileType"];
            alignedSequences: components["schemas"]["SequenceAlign"][];
            entitySequences: components["schemas"]["BasicEntitySequence"][];
        };
        ExternalLink: {
            label?: string;
            link?: string;
            type?: components["schemas"]["LinkTypeEnum"];
        };
        /** External Reference */
        ExternalReferenceResponse: {
            displayName: string;
            link: string;
        };
        /** Family Member Request */
        FamilyMemberRequest: {
            /** Format: int64 */
            featureId: number;
            trackId: string;
        };
        /** Family Member Response */
        FamilyMemberResponse: {
            /** Format: int64 */
            featureId: number;
            trackId: string;
        };
        /** @enum {string} */
        FastaHeaderFormatEnum: FastaHeaderFormatEnum;
        /** Feature Contig Location */
        FeatureContigLocationResponse: {
            /** Format: int64 */
            contigId: number;
            /** Format: int64 */
            featureId: number;
            /** Format: int64 */
            otherGenomesMemberCount?: number;
            /** Format: int64 */
            sameGenomeMemberCount?: number;
        };
        /**
         * Feature Location
         * @description Represents basic location information of a feature for the context entity.
         */
        FeatureLocationResponse: {
            /** Format: int64 */
            contigId: number;
            contigSequenceId: string;
            /** Format: int64 */
            id: number;
            name: string;
            range: components["schemas"]["RangeResponse"];
            /** Format: int64 */
            subTypeId?: number;
            subTypeName?: string;
        };
        /**
         * Feature
         * @description Represents basic information of a feature for the context entity.
         */
        FeatureResponse: {
            /** Format: int64 */
            contigId: number;
            description?: string;
            extReferences?: components["schemas"]["ExternalReferenceResponse"][];
            gene?: components["schemas"]["GeneInfoResponse"];
            /** Format: int64 */
            id: number;
            name: string;
            /** Format: int64 */
            orgId: number;
            pValue?: string;
            protein?: components["schemas"]["ProteinInfoResponse"];
            score?: number;
            /** Format: int64 */
            sequenceTypeId?: number;
            /** Format: int64 */
            start?: number;
            status?: string;
            /** Format: int64 */
            stop?: number;
            strand?: string;
            synonyms?: string[];
            transcript?: components["schemas"]["TranscriptInfoResponse"];
        };
        /**
         * Feature Type
         * @enum {string}
         */
        FeatureType: FeatureType;
        /**
         * FeatureType
         * @description Represents a feature type for the context entity.
         */
        FeatureTypeResponse: {
            colour?: string;
            /** Format: int64 */
            count?: number;
            /** Format: int64 */
            id: number;
            name: string;
        };
        /**
         * Feature Type Track Colors
         * @description Coloring of feature tracks per Contig
         */
        FeatureTypeTrackColor: {
            color: string;
            /** Format: int64 */
            featureTypeId: number;
        };
        /**
         * FeatureTypes
         * @description Represents all available feature types for the context entity.
         */
        FeatureTypesResponse: {
            aaFeatureTypes: components["schemas"]["FeatureTypeResponse"][];
            markerTypes: components["schemas"]["FeatureTypeResponse"][];
            nuFeatureTypes: components["schemas"]["FeatureTypeResponse"][];
        };
        FilterOption: {
            displayKey: string;
            displayName: string;
            /** Format: int32 */
            numberOfInputs?: number;
        };
        /**
         * Gene info
         * @description Gene basic information.
         */
        GeneInfoResponse: {
            description?: string;
            /** Format: int64 */
            id: number;
            name: string;
        };
        /** Genome Category Response */
        GenomeCategoryResponse: {
            categoryResponses: components["schemas"]["CategoryResponse"][];
            /** Format: int64 */
            genomeId: number;
            genomeName: string;
        };
        /**
         * Genome info
         * @description Genome basic information.
         */
        GenomeInfoResponse: {
            customId: string;
            description?: string;
            /** Format: int64 */
            id: number;
            identifier: string;
            isVirtual: boolean;
            name: string;
            sequencingType: components["schemas"]["SequencingTypeEnum"];
            version?: string;
        };
        /** GenomeUsergroupIntersectionRequest */
        GenomeUsergroupIntersectionRequest: {
            genomeIds: number[];
        };
        /** GenomeUsergroupIntersectionResponse */
        GenomeUsergroupIntersectionResponse: {
            commonUsergroups: components["schemas"]["UsergroupResponse"][];
        };
        /** @enum {string} */
        GenomicFeatureTypeEnum: GenomicFeatureTypeEnum;
        /** Graphics Request */
        GraphicsRequest: {
            /** Format: int32 */
            baseShift: number;
            isVisible: boolean;
            /** Format: int32 */
            length: number;
        };
        /** Graphics Response */
        GraphicsResponse: {
            /** Format: int32 */
            baseShift: number;
            isVisible: boolean;
            /** Format: int32 */
            length: number;
        };
        /**
         * Group info
         * @description Group basic information.
         */
        GroupInfoResponse: {
            /** Format: int64 */
            id: number;
            type: components["schemas"]["GroupTypeEnum"];
        };
        /** @enum {string} */
        GroupTypeEnum: GroupTypeEnum;
        /** Invalid Sequences Response */
        InvalidSequencesResponse: {
            messages?: components["schemas"]["Message"][];
            payload: string[];
        };
        /** Item Response */
        ItemResponse: {
            /** Format: int64 */
            contigId: number;
            contigName: string;
            /** Format: int64 */
            id: number;
            name: string;
            /** Format: int64 */
            orgId: number;
            orgName: string;
            seqId: string;
            /** Format: int64 */
            start: number;
            /** Format: int64 */
            stop: number;
        };
        /** Item Tag */
        ItemTagResponse: {
            color?: string;
            /** Format: int64 */
            id: number;
            name: string;
            /** Format: int64 */
            projectId: number;
        };
        /** @enum {string} */
        LinkTypeEnum: LinkTypeEnum;
        /** Message */
        Message: {
            severity: components["schemas"]["SeverityConstants"];
            text: string;
        };
        /**
         * Method Key
         * @enum {string}
         */
        MethodKeyEnum: MethodKeyEnum;
        NumberColumnFilter: {
            filterType: "NumberColumnFilter";
        } & (Omit<WithRequired<components["schemas"]["ColumnFilter"], "filterType">, "filterType"> & {
            filter: string;
            filterTo?: string;
            type: string;
        });
        /** Open File Payload */
        OpenFilePayload: {
            alignedSequences?: components["schemas"]["SequenceAlign"][];
            entitySequences: components["schemas"]["EntitySequence"][];
        };
        /** Open File Request */
        OpenFileRequest: {
            fileContent: components["schemas"]["TextFile"];
        };
        /** Open File Response */
        OpenFileResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["OpenFilePayload"];
        };
        /** Organism */
        OrganismResponse: {
            contigs: components["schemas"]["ContigResponse"][];
            /** Format: int64 */
            id: number;
            name: string;
        };
        /**
         * Pileup Rendering Mode
         * @enum {string}
         */
        PileupRenderingModeEnum: PileupRenderingModeEnum;
        /**
         * Protein info
         * @description Protein basic information.
         */
        ProteinInfoResponse: {
            accession: string;
            description?: string;
            /** Format: int64 */
            id: number;
            name: string;
            sequenceId: string;
            /** Format: int32 */
            version: number;
        };
        RangeRequest: {
            /** Format: int32 */
            start: number;
            /** Format: int32 */
            stop: number;
        };
        /** Range Response */
        RangeResponse: {
            /** Format: int64 */
            start: number;
            /** Format: int64 */
            stop: number;
        };
        /** Region Export Request */
        RegionExportRequest: {
            compressed: boolean;
            fileName: string;
            headerFormat: components["schemas"]["FastaHeaderFormatEnum"];
            regions: components["schemas"]["RegionRequest"][];
            reverseComplement: boolean;
            tableExportFormat: components["schemas"]["TableExportFormat"];
        };
        /** @description Defines the  contig regions to restrict to */
        RegionRequest: {
            /** Format: int64 */
            contigId: number;
            range?: components["schemas"]["RangeRequest"];
        };
        /**
         * Row Index
         * @description Row Index of selected feature.
         */
        RowIndexResponse: {
            /** Format: int32 */
            rowIndex: number;
        };
        /** @enum {string} */
        SORT_DIRECTION: SORT_DIRECTION;
        SampleCell: {
            created?: string;
            deleted?: boolean;
            description?: string;
            hidden?: boolean;
            /** Format: int64 */
            id?: number;
            locked?: boolean;
            modified?: string;
            name?: string;
            projectColor?: string;
            /** Format: int64 */
            projectId?: number;
            projectName?: string;
            statusColor?: string;
            statusName?: string;
            /** Format: int64 */
            typeId?: number;
            typeName?: string;
        };
        /** Search Feature Request */
        SearchFeatureRequest: {
            /** Format: int64 */
            genomeId: number;
            /** Format: int32 */
            limit?: number;
            searchTerm: string;
            types: components["schemas"]["SearchGenomicEntityTypeRequest"][];
        };
        /** Search Feature Response */
        SearchFeatureResponse: {
            categories: components["schemas"]["GenomeCategoryResponse"][];
        };
        /** Search Genomic Entity Type Request */
        SearchGenomicEntityTypeRequest: {
            subTypeIds?: number[];
            type: components["schemas"]["GenomicFeatureTypeEnum"];
        };
        /**
         * Sequence selection
         * @description The part of the sequence selected
         */
        Selection: {
            /** Format: int32 */
            positionEnd: number;
            /** Format: int32 */
            positionStart: number;
        };
        /**
         * Sequence Align
         * @description Representation of aligned sequence residues
         */
        SequenceAlign: {
            /** Format: int64 */
            id: number;
            residues: string;
        };
        /**
         * Sequence Analyzer Feature Type
         * @enum {string}
         */
        SequenceAnalyzerFeatureType: SequenceAnalyzerFeatureType;
        /**
         * File Type
         * @enum {string}
         */
        SequenceExportFileType: SequenceExportFileType;
        /** Sequence Feature */
        SequenceFeature: {
            color?: string;
            description?: string;
            directStrand: boolean;
            forceColor?: string;
            /** Format: int64 */
            id: number;
            name?: string;
            /** Format: double */
            score?: number;
            /** Format: int32 */
            start: number;
            /** Format: int32 */
            stop: number;
            type: string;
            /** Format: int64 */
            typeId?: number;
            typeKey?: string;
        };
        /**
         * Sequence feature color
         * @description Color specified by default or updated by a user for either a feature type of feature name
         */
        SequenceFeatureColor: {
            color?: string;
            /** Format: int64 */
            featureTypeId: number;
            label?: boolean;
            setting?: components["schemas"]["SequenceFeatureTypeColorSetting"];
        };
        /** Sequence feature colors */
        SequenceFeatureColorsResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["SequenceFeatureColor"][];
        };
        /**
         * Sequence Feature Type Color Setting
         * @enum {string}
         */
        SequenceFeatureTypeColorSetting: SequenceFeatureTypeColorSetting;
        /**
         * Sequence Type
         * @enum {string}
         */
        SequenceType: SequenceType;
        /** Sequences Align Payload */
        SequencesAlignPayload: {
            sequences: components["schemas"]["SequenceAlign"][];
        };
        /** Sequences Align Request */
        SequencesAlignRequest: {
            alignmentOptions: components["schemas"]["AlignmentOptions"];
            sequences: components["schemas"]["SequenceAlign"][];
        };
        /** Sequences Align Response */
        SequencesAlignResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["SequencesAlignPayload"];
        };
        /**
         * Sequencing Type
         * @enum {string}
         */
        SequencingTypeEnum: SequencingTypeEnum;
        /** Session */
        Session: {
            alignedSequences?: components["schemas"]["SequenceAlign"][];
            alignmentOptionsDescription: string;
            alignmentToolLabel: string;
            canCreateHitList: boolean;
            cannotCreateHitListMessage?: string;
            createHitListLabel: string;
            documentationLabel: string;
            documentationUrl: string;
            entitySequences: components["schemas"]["EntitySequence"][];
            id: string;
            maskingResidue?: string;
            sequenceClassLabelPlural: string;
            sequenceClassLabelSingular: string;
            sequenceType: components["schemas"]["SequenceType"];
        };
        /** Session From Ranges Request */
        SessionFromRangesRequest: {
            ranges?: components["schemas"]["ContigRange"][];
        };
        /** Session Request */
        SessionRequest: {
            featureType?: components["schemas"]["SequenceAnalyzerFeatureType"];
            sequenceIds?: number[];
        };
        /** Session Validity Response */
        SessionValidityResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["Session"];
            type?: string;
        };
        SetColumnFilter: {
            filterType: "SetColumnFilter";
        } & (Omit<WithRequired<components["schemas"]["ColumnFilter"], "filterType">, "filterType"> & {
            type?: string;
            values: string[];
        });
        /**
         * Severity Constants
         * @enum {string}
         */
        SeverityConstants: SeverityConstants;
        /** Similarity Tree Request */
        SimilarityTreeRequest: {
            sequences: components["schemas"]["SequenceAlign"][];
        };
        /** Similarity Tree Response */
        SimilarityTreeResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["DistanceTreeNode"];
        };
        /** Slow Alignment Options */
        SlowAlignmentOptions: {
            /**
             * Format: double
             * @description Maps to ClustalW GAPOPEN parameter: gap opening penalty
             */
            gapCreationPenalty?: number;
            /** Format: double */
            gapExtensionPenalty?: number;
            /** Format: int32 */
            identity?: number;
        };
        /** @description Sort order, or empty list */
        SortModel: {
            colId?: string;
            sort?: components["schemas"]["SORT_DIRECTION"];
        };
        /** State Request */
        StateRequest: {
            /** Format: int64 */
            activeMemberId?: number;
            alignedFamily?: components["schemas"]["AlignedFamilyRequest"];
            alignmentDensity: components["schemas"]["AlignmentDensityEnum"];
            /** Format: double */
            basePerPixel: number;
            /** Format: int64 */
            organismId: number;
            pileupRenderingMode: components["schemas"]["PileupRenderingModeEnum"];
            /** Format: double */
            scrollX: number;
            /** Format: double */
            scrollY: number;
            showTable?: boolean;
            table?: components["schemas"]["TableRequest"];
            trackGroups: components["schemas"]["TrackGroupRequest"][];
            tracks: components["schemas"]["TrackRequest"][];
        };
        /** State Response */
        StateResponse: {
            /** Format: int64 */
            activeMemberId?: number;
            alignedFamily?: components["schemas"]["AlignedFamilyResponse"];
            alignmentDensity: components["schemas"]["AlignmentDensityEnum"];
            /** Format: double */
            basePerPixel: number;
            /** Format: int64 */
            organismId: number;
            pileupRenderingMode: components["schemas"]["PileupRenderingModeEnum"];
            /** Format: double */
            scrollX: number;
            /** Format: double */
            scrollY: number;
            showTable?: boolean;
            table?: components["schemas"]["TableRequest"];
            trackGroups: components["schemas"]["TrackGroupResponse"][];
            tracks: components["schemas"]["TrackResponse"][];
        };
        /** Strands Payload */
        StrandsPayload: {
            entitySequences: components["schemas"]["EntitySequence"][];
        };
        /** Strands Request */
        StrandsRequest: {
            entitySequences: components["schemas"]["EntitySequence"][];
        };
        /** Strands Response */
        StrandsResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["StrandsPayload"];
        };
        /** Synteny Family Contig */
        SyntenyFamilyContigResponse: {
            /** Format: int64 */
            contigId: number;
            contigName: string;
            /** Format: int64 */
            length: number;
            members: components["schemas"]["SyntenyFamilyMemberResponse"][];
        };
        /** Synteny Family Member */
        SyntenyFamilyMemberResponse: {
            /** Format: int64 */
            locationId: number;
            /** Format: int64 */
            memberId?: number;
            memberName: string;
            /** Format: int64 */
            start: number;
            /** Format: int64 */
            stop: number;
        };
        /** Synteny Family Organism */
        SyntenyFamilyOrganismResponse: {
            contigs: components["schemas"]["SyntenyFamilyContigResponse"][];
            /** Format: int64 */
            organismId: number;
            organismName: string;
        };
        /** Synteny Family */
        SyntenyFamilyResponse: {
            /** Format: int64 */
            id: number;
            members: components["schemas"]["FeatureContigLocationResponse"][];
        };
        /** @enum {string} */
        SyntenyTypeEnum: SyntenyTypeEnum;
        /** Synteny View */
        SyntenyViewResponse: {
            description?: string;
            /** Format: int64 */
            id: number;
            itemTags?: components["schemas"]["ItemTagResponse"][];
            path: string;
            /** Format: int64 */
            projectId: number;
            shared: boolean;
            state: components["schemas"]["StateResponse"];
            viewLabel: string;
            viewName: string;
            viewType: string;
        };
        /** @enum {string} */
        TableExportFormat: TableExportFormat;
        TableExportRequest: {
            compressed: boolean;
            fileName: string;
            format: components["schemas"]["TableExportFormat"];
            headerFormat?: components["schemas"]["FastaHeaderFormatEnum"];
            reverseComplement: boolean;
            table: components["schemas"]["TableRequest"];
        };
        TableRequest: {
            /** @description Defines the content to include in the response. */
            content: components["schemas"]["Content"][];
            /**
             * Format: int32
             * @description Pagination end row
             */
            endRow: number;
            /** @description Filter model or empty map. */
            filterModel: {
                [key: string]: components["schemas"]["ColumnFilter"];
            };
            /**
             * @description The type of 'id', either 'GROUP' or 'ENTITY'.
             * @enum {string}
             */
            idType: TableRequestIdType;
            ids: number[];
            queryType?: components["schemas"]["TableTypeEnum"];
            /**
             * Format: int64
             * @description Defines the reference genome.
             */
            refGenomeId?: number;
            /** @description Defines the  contig regions to restrict to */
            regions?: components["schemas"]["RegionRequest"][];
            resultType: components["schemas"]["TableTypeEnum"];
            /** @description List of selected ids to filter to or empty */
            selectedIds?: number[];
            /** @description Sort order, or empty list */
            sortModel: components["schemas"]["SortModel"][];
            /**
             * Format: int32
             * @description Pagination start row
             */
            startRow: number;
            /**
             * Format: int64
             * @description Id of the sub-type, if applicable
             */
            subTypeId?: number;
            /** @description Columns for which data should be returned */
            valueCols: components["schemas"]["ColumnRequest"][];
        };
        TableResponse: {
            /** @description List of all columns that are possible for this table, including hidden ones, empty if not requested. */
            allColumns: components["schemas"]["ColumnSparseResponse"][];
            /** @description List of columns for which data was requested, empty if not requested. */
            columns: components["schemas"]["ColumnResponse"][];
            /** @description List of row data. Values are keyed by column id, empty if not requested. */
            data: components["schemas"]["ColumnMap"][];
            /**
             * Format: int32
             * @description Number of rows in the table for the given restrictions and filter
             */
            filteredCount?: number;
            /**
             * Format: int32
             * @description The current last row or -1 if the requested end row was behind the end of the data.
             */
            lastRow: number;
            /**
             * Format: int32
             * @description Number of rows in the table for the given restrictions
             */
            restrictedCount?: number;
            /** @description Row ids, empty if not requested. */
            rowIds: number[];
            /**
             * Format: int32
             * @description Number of rows in the table
             */
            totalCount?: number;
        };
        /**
         * @description Type of rows of the table
         * @enum {string}
         */
        TableTypeEnum: TableTypeEnum;
        TemplateResponse: {
            active?: boolean;
            /** @description The name of the template */
            columns: components["schemas"]["ColumnSparseResponse"][];
            /**
             * Format: int64
             * @description The id of the template
             */
            id: number;
            isDefault?: boolean;
            /** @description The name of the template */
            name: string;
            selected?: boolean;
        };
        TextColumnFilter: {
            filterType: "TextColumnFilter";
        } & (Omit<WithRequired<components["schemas"]["ColumnFilter"], "filterType">, "filterType"> & {
            filter: string;
            filterTo?: string;
            type: string;
        });
        /** Text File */
        TextFile: {
            content?: string;
            encoding?: string;
            name?: string;
        };
        /**
         * Track Colors
         * @description Coloring of tracks per Contig
         */
        TrackColors: {
            gene?: string;
            nuFeatures?: components["schemas"]["FeatureTypeTrackColor"][];
            protein?: string;
            transcript?: string;
        };
        /** @enum {string} */
        TrackEnum: TrackEnum;
        /** Track feature */
        TrackFeatureResponse: {
            /** Format: int64 */
            id: number;
            mappings?: components["schemas"]["RangeResponse"][];
            name: string;
            representer: boolean;
            /** Format: int64 */
            start: number;
            /** Format: int64 */
            stop: number;
            strand?: string;
        };
        /** Track Group Request */
        TrackGroupRequest: {
            /** Format: int64 */
            contigId: number;
            graphics: components["schemas"]["GraphicsRequest"];
            groupId: string;
            /** Format: int64 */
            organismId: number;
            trackIds: string[];
        };
        /** Track Group Response */
        TrackGroupResponse: {
            /** Format: int64 */
            contigId: number;
            contigSequenceId: string;
            graphics: components["schemas"]["GraphicsResponse"];
            groupId: string;
            /** Format: int64 */
            organismId: number;
            organismName: string;
            trackIds: string[];
        };
        /** Track Request */
        TrackRequest: {
            /** Format: double */
            basePerPixel: number;
            /** Format: int32 */
            baseStart: number;
            color: string;
            groupId: string;
            /** Format: int32 */
            height: number;
            isVisible: boolean;
            /** Format: int64 */
            subTypeId?: number;
            synteny: boolean;
            text: components["schemas"]["TrackTextEnum"];
            trackId: string;
            trackType: components["schemas"]["TrackEnum"];
            /** Format: int32 */
            width: number;
        };
        /** Track Response */
        TrackResponse: {
            /** Format: double */
            basePerPixel: number;
            /** Format: int32 */
            baseStart: number;
            color: string;
            groupId: string;
            /** Format: int32 */
            height: number;
            isVisible: boolean;
            subType?: components["schemas"]["FeatureTypeResponse"];
            /** Format: int64 */
            subTypeId?: number;
            synteny: boolean;
            text: components["schemas"]["TrackTextEnum"];
            trackId: string;
            trackType: components["schemas"]["TrackEnum"];
            /** Format: int32 */
            width: number;
        };
        /**
         * Track Text
         * @enum {string}
         */
        TrackTextEnum: TrackTextEnum;
        /**
         * Transcript info
         * @description Transcript basic information.
         */
        TranscriptInfoResponse: {
            accession: string;
            description?: string;
            /** Format: int64 */
            id: number;
            name: string;
            sequenceId: string;
            /** Format: int32 */
            version: number;
        };
        UpdateTemplateRequest: {
            /** @description The list of columns to set */
            columns: components["schemas"]["ColumnSparseResponse"][];
            /**
             * Format: int64
             * @description Id of the template, empty falls back to the active template.
             */
            id?: number;
            queryType?: components["schemas"]["TableTypeEnum"];
            resultType: components["schemas"]["TableTypeEnum"];
        };
        /** User Audit Event Request */
        UserAuditEventRequest: {
            message: string;
            payload?: string;
            /** Format: int64 */
            type: number;
        };
        /** Usergroup */
        UsergroupResponse: {
            /** Format: int64 */
            id: number;
            isPrivate: boolean;
            name: string;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    logUserEvent: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description User event payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserAuditEventRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getContigFeatureTypes: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                contigId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeatureTypesResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSequence: {
        parameters: {
            query?: {
                /** @description range start position */
                start?: number;
                /** @description range stop position */
                stop?: number;
                /** @description strand, defaults to + */
                strand?: string;
            };
            header?: never;
            path: {
                /** @description contig id */
                contigId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getTrackFeatures: {
        parameters: {
            query?: {
                /** @description Track feature subtype id */
                subtypeId?: number;
                /** @description range start position */
                start?: number;
                /** @description range stop position */
                stop?: number;
                /** @description synteny organism id (used to improve condensed mode) */
                syntenyOrgId?: number;
                condense?: boolean;
            };
            header?: never;
            path: {
                contigId: number;
                trackType: components["schemas"]["TrackEnum"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TrackFeatureResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    downloadFilescannerReport: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    sequenceRegionExport: {
        parameters: {
            query: {
                /** @description new unique key associated to the prepared file */
                fileKey: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequence regions export payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RegionExportRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Request accepted for processing but has not been completed yet. */
            202: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    tableExport: {
        parameters: {
            query: {
                /** @description new unique key associated to the prepared file */
                fileKey: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description table export payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["TableExportRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Request accepted for processing but has not been completed yet. */
            202: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getPangenomeFeature: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description pangenome organism id */
                pangenomeOrgId: number;
                featureId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeatureResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getFeature: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                type: components["schemas"]["GenomicFeatureTypeEnum"];
                featureId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeatureResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getFeatureLocation: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                type: components["schemas"]["GenomicFeatureTypeEnum"];
                featureId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeatureLocationResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    featureRowId: {
        parameters: {
            query: {
                /** @description the id of the selected feature */
                featureId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Specification of the requested table */
        requestBody: {
            content: {
                "application/json": components["schemas"]["TableRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RowIndexResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    triggerDeletion: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    triggerStaleScan: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getComponentGenomes: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description organism id */
                orgId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrganismResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getUsergroupIntersection: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description genome ids payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["GenomeUsergroupIntersectionRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GenomeUsergroupIntersectionResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGenomeFeatureTypes: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                orgId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeatureTypesResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGenomeInfo: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description organism id */
                orgId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GenomeInfoResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getTemplates: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Specification of the table */
        requestBody: {
            content: {
                "application/json": components["schemas"]["TableRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TemplateResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createGroup: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description group contents payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateGroupRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GroupInfoResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    previewFilescannerReport: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Request accepted but no content to return. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    previewFile: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description project file id */
                fileId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSearchResult: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description genomic feature search request */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SearchFeatureRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SearchFeatureResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createSession: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequence ids payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SessionRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createSessionFromRanges: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequence ranges payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SessionFromRangesRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSequenceFeatureColors: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Get current users' colors for a given sequence type */
                sequenceType: components["schemas"]["SequenceType"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SequenceFeatureColorsResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSeqAnalyzerSession: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description sequence analyzer session id */
                seqAnalyzerSessionId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Session"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    isSessionValid: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description sequence analyzer session id */
                seqAnalyzerSessionId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SessionValidityResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    addSequencesToSession: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description sequence analyzer session id */
                seqAnalyzerSessionId: string;
            };
            cookie?: never;
        };
        /** @description sequences payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["OpenFileRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OpenFileResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    switchStrand: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description sequence analyzer session id */
                seqAnalyzerSessionId: string;
            };
            cookie?: never;
        };
        /** @description sequences payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["StrandsRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StrandsResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    validateSequences: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequence ids payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SessionRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InvalidSequencesResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    align: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequences align request */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SequencesAlignRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SequencesAlignResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    order: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequences align request */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SequencesAlignRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SequencesAlignResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    tree: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequences similarity tree request */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SimilarityTreeRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SimilarityTreeResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    exportFile: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description sequence analyzer session id */
                seqAnalyzerSessionId: string;
            };
            cookie?: never;
        };
        /** @description sequences export request */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ExportFileRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getProteinFamilyMembers: {
        parameters: {
            query?: {
                condense?: boolean;
            };
            header?: never;
            path: {
                familyId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyOrganismResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getPangenomeAlignmentMembers: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description pangenome organism id */
                pangenomeOrgId: number;
                familyId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyOrganismResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getPangenomeAlignmentFeatureMembers: {
        parameters: {
            query?: {
                condense?: boolean;
            };
            header?: never;
            path: {
                /** @description pangenome organism id */
                pangenomeOrgId: number;
                featureType: components["schemas"]["GenomicFeatureTypeEnum"];
                featureId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyOrganismResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getPangenomeAlignments: {
        parameters: {
            query?: {
                /** @description range start position */
                start?: number;
                /** @description range stop position */
                stop?: number;
                /** @description feature minimum length */
                minLength?: number;
            };
            header?: never;
            path: {
                /** @description pangenome organism id */
                pangenomeOrgId: number;
                /** @description contig id part of the pangenome */
                contigId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getAlignmentStatistics: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description pangenome organism id */
                pangenomeOrgId: number;
                /** @description contig id part of the pangenome */
                contigId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AlignmentStatsResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getPangenomeTrackFeatures: {
        parameters: {
            query?: {
                /** @description range start position */
                start?: number;
                /** @description range stop position */
                stop?: number;
                /** @description feature minimum length */
                minLength?: number;
            };
            header?: never;
            path: {
                pangenomeOrgId: number;
                contigId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TrackFeatureResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getContigsWithSyntenyFamilies: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description synteny organism id */
                syntenyOrgId: number;
                /** @description organism id */
                orgId: number;
                syntenyType: components["schemas"]["SyntenyTypeEnum"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": number[];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getProteinFamilies: {
        parameters: {
            query: {
                contigIds: number[];
                condense?: boolean;
            };
            header?: never;
            path: {
                /** @description synteny organism id */
                syntenyOrgId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getFeatureSyntenyFamilyMembers: {
        parameters: {
            query?: {
                condense?: boolean;
            };
            header?: never;
            path: {
                /** @description synteny organism id */
                syntenyOrgId: number;
                syntenyType: components["schemas"]["SyntenyTypeEnum"];
                featureId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyOrganismResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    table: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Specification of the requested table */
        requestBody: {
            content: {
                "application/json": components["schemas"]["TableRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TableResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    updateTemplate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Specification of the template */
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateTemplateRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RowIndexResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createTemplate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Specification of the template */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateTemplateRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    deleteTemplate: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                templateId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    isProjectCompatible: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description the id of the project */
                projectId: number;
                /** @description the id of the organism */
                organismId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CompatibilityResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    editSyntenyView: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description view contents payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateOrUpdateSyntenyViewRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": number;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createSyntenyView: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description view contents payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateOrUpdateSyntenyViewRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": number;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    loadSyntenyView: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description synteny view id */
                viewId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyViewResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description User is not allowed to perform operation. */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
}
export enum AlignmentDensityEnum {
    SINGLE = "SINGLE",
    LOW = "LOW",
    OFF = "OFF"
}
type WithRequired<T, K extends keyof T> = T & {
    [P in K]-?: T[P];
};
export enum CellType {
    STRING = "STRING",
    BOOLEAN = "BOOLEAN",
    SCIENTIFIC = "SCIENTIFIC",
    INTEGER = "INTEGER",
    LONG = "LONG",
    FLOAT = "FLOAT",
    DOUBLE = "DOUBLE",
    BIG_DECIMAL = "BIG_DECIMAL",
    FILE = "FILE",
    ORGANISM = "ORGANISM",
    DATE = "DATE",
    DATE_TIME = "DATE_TIME",
    STRING_LIST = "STRING_LIST",
    BOOLEAN_LIST = "BOOLEAN_LIST",
    INTEGER_LIST = "INTEGER_LIST",
    LONG_LIST = "LONG_LIST",
    FLOAT_LIST = "FLOAT_LIST",
    DOUBLE_LIST = "DOUBLE_LIST",
    FILE_LIST = "FILE_LIST",
    DATE_LIST = "DATE_LIST",
    NESTED_STRING_LIST = "NESTED_STRING_LIST",
    NESTED_INTEGER_LIST = "NESTED_INTEGER_LIST",
    NESTED_LONG_LIST = "NESTED_LONG_LIST",
    NESTED_FLOAT_LIST = "NESTED_FLOAT_LIST",
    NESTED_DOUBLE_LIST = "NESTED_DOUBLE_LIST",
    VARIANT_PROFILE = "VARIANT_PROFILE",
    STRAND = "STRAND",
    STRAND_LIST = "STRAND_LIST",
    LINK = "LINK",
    LINK_EXTERNAL = "LINK_EXTERNAL",
    LINK_LIST = "LINK_LIST",
    LINK_EXTERNAL_LIST = "LINK_EXTERNAL_LIST",
    SAMPLE = "SAMPLE",
    SAMPLE_LIST = "SAMPLE_LIST",
    COLOR_STRING = "COLOR_STRING",
    COLOR_NUM = "COLOR_NUM",
    COLOR_STRING_LIST = "COLOR_STRING_LIST",
    COLOR_NUM_LIST = "COLOR_NUM_LIST",
    PERCENT = "PERCENT",
    BLAST_ALIGNMENT_LIST = "BLAST_ALIGNMENT_LIST"
}
export enum Content {
    COLUMNS = "COLUMNS",
    ALL_COLUMNS = "ALL_COLUMNS",
    ROWS = "ROWS",
    COUNTS = "COUNTS",
    ROW_IDS = "ROW_IDS"
}
export enum FastaHeaderFormatEnum {
    DEFAULT = "DEFAULT",
    SELECTOR_IDENTIFIERS = "SELECTOR_IDENTIFIERS",
    PROFILER_IDENTIFIERS = "PROFILER_IDENTIFIERS",
    VISIBLE_COLUMNS = "VISIBLE_COLUMNS",
    RAW = "RAW"
}
export enum FeatureType {
    gene = "gene",
    protein = "protein",
    transcript = "transcript"
}
export enum GenomicFeatureTypeEnum {
    GENE = "GENE",
    TRANSCRIPT = "TRANSCRIPT",
    TRANSCRIPT_LOCATION = "TRANSCRIPT_LOCATION",
    PROTEIN = "PROTEIN",
    PROTEIN_LOCATION = "PROTEIN_LOCATION",
    ORGANISM = "ORGANISM",
    CONTIG = "CONTIG",
    REGION_FLAG = "REGION_FLAG",
    COORDINATE = "COORDINATE",
    NUCLEOTIDE_FEATURE = "NUCLEOTIDE_FEATURE",
    AA_SEQUENCE_FEATURE = "AA_SEQUENCE_FEATURE",
    VCF_VARIANT = "VCF_VARIANT",
    MARKER = "MARKER",
    MARKER_NUS = "MARKER_NUS"
}
export enum GroupTypeEnum {
    GENE = "GENE",
    TRANSCRIPT = "TRANSCRIPT",
    PROTEIN = "PROTEIN",
    NU_FEATURE = "NU_FEATURE",
    AA_FEATURE = "AA_FEATURE"
}
export enum LinkTypeEnum {
    GENE = "GENE",
    TRANSCRIPT = "TRANSCRIPT",
    TRANSCRIPT_LOCATION = "TRANSCRIPT_LOCATION",
    PROTEIN = "PROTEIN",
    PROTEIN_LOCATION = "PROTEIN_LOCATION",
    PROBE = "PROBE",
    ORGANISM = "ORGANISM",
    CONTIG = "CONTIG",
    SEQUENCE = "SEQUENCE",
    NUCLEOTIDE_FEATURE = "NUCLEOTIDE_FEATURE",
    AA_SEQUENCE_FEATURE = "AA_SEQUENCE_FEATURE",
    VCF_VARIANT = "VCF_VARIANT",
    MARKER = "MARKER",
    MARKER_NUS = "MARKER_NUS",
    EXT_ENTRY = "EXT_ENTRY",
    SAMPLE = "SAMPLE",
    OTHER = "OTHER"
}
export enum MethodKeyEnum {
    fast = "fast",
    slow = "slow"
}
export enum PileupRenderingModeEnum {
    CONDENSED = "CONDENSED",
    EXPANDED = "EXPANDED"
}
export enum SORT_DIRECTION {
    asc = "asc",
    desc = "desc"
}
export enum SequenceAnalyzerFeatureType {
    gene = "gene",
    protein = "protein",
    proteinLocation = "proteinLocation",
    transcript = "transcript",
    transcriptLocation = "transcriptLocation"
}
export enum SequenceExportFileType {
    msf = "msf",
    fasta = "fasta"
}
export enum SequenceFeatureTypeColorSetting {
    Identical = "Identical",
    Distinct = "Distinct",
    Shade = "Shade"
}
export enum SequenceType {
    dna = "dna",
    protein = "protein"
}
export enum SequencingTypeEnum {
    UNKNOWN = "UNKNOWN",
    NOT_SEQUENCED = "NOT_SEQUENCED",
    SEQUENCED_ASSEMBLY = "SEQUENCED_ASSEMBLY",
    RE_SEQUENCED = "RE_SEQUENCED",
    RE_SEQUENCED_VCF = "RE_SEQUENCED_VCF",
    VECTOR = "VECTOR",
    VIRTUAL = "VIRTUAL",
    PROTEIN_SYNTENY = "PROTEIN_SYNTENY",
    PANGENOME = "PANGENOME"
}
export enum SeverityConstants {
    DEBUG = "DEBUG",
    DETAIL = "DETAIL",
    INFO = "INFO",
    WARN = "WARN",
    ERROR = "ERROR"
}
export enum SyntenyTypeEnum {
    PROTEIN = "PROTEIN",
    GENOME_ALIGNMENT = "GENOME_ALIGNMENT"
}
export enum TableExportFormat {
    GCD = "GCD",
    EXCEL_XLSX = "EXCEL_XLSX",
    FASTA = "FASTA",
    RAW = "RAW",
    VCF = "VCF"
}
export enum TableRequestIdType {
    ENTITY = "ENTITY",
    GROUP = "GROUP"
}
export enum TableTypeEnum {
    ORGANISM = "ORGANISM",
    GENE = "GENE",
    TRANSCRIPT = "TRANSCRIPT",
    TRANSCRIPT_LOCATION = "TRANSCRIPT_LOCATION",
    PROTEIN = "PROTEIN",
    PROTEIN_LOCATION = "PROTEIN_LOCATION",
    NU_FEATURE = "NU_FEATURE",
    PANGENOME = "PANGENOME"
}
export enum TrackEnum {
    GENE = "GENE",
    TRANSCRIPT_LOCATION = "TRANSCRIPT_LOCATION",
    PROTEIN_LOCATION = "PROTEIN_LOCATION",
    VARIANT = "VARIANT",
    VCF_VARIANT = "VCF_VARIANT",
    SEQUENCE = "SEQUENCE",
    BLAST_ALIGNMENT = "BLAST_ALIGNMENT",
    PROFILE = "PROFILE",
    NUCLEOTIDE_FEATURE = "NUCLEOTIDE_FEATURE",
    AA_SEQUENCE_FEATURE = "AA_SEQUENCE_FEATURE",
    MARKER_NUS = "MARKER_NUS",
    BED_FEATURE = "BED_FEATURE",
    COORDINATE = "COORDINATE",
    NGS = "NGS",
    COORDINATE_LIST = "COORDINATE_LIST"
}
export enum TrackTextEnum {
    NONE = "NONE",
    INNER = "INNER",
    OUTER = "OUTER"
}
